import React from 'react';
import './home/home.css'
import Menu from './menu';
import { rIconWhite, rIconWhite20 } from '../static/svgs';
import { useLocation } from 'react-router-dom';

function MainMenu({ handleClickUser }) {
  const location = useLocation();
  return (
    <>
    <Menu handleClickUser={handleClickUser} />
    <div className={`home_menu_cntr ${(location.pathname === "/chat" ? 'menu_mobile': '' )}`}>
      <div className='home_logo_cntr'>
        <div className='home_cntr2_ricon'>
          <div className='home_cntr_ricon'>
            {rIconWhite}
          </div>
        </div>
        <div>
          <div className='home_logo_cntr2'>
            {rIconWhite20}
            <label style={{marginLeft: '-5px'}} className='philosopher-bold-italic color_white'>егистратор</label>
          </div>
          <label className='manrope-600 color_white'>Услуги для вашего бизнеса</label>
        </div>
      </div>
      
    </div>
    </>
  );
}

export default MainMenu;
